module.exports = __webpack_public_path__ + "static/media/speakers1.d0c7bf43.jpg";